import React from 'react';
import { OBSERVATORY_VOICES } from '../../data/ecoContent';
import { DoubleBezelCard } from '../common/DoubleBezelCard';

export const ScientificVoices: React.FC = () => {
  return (
    <section
      id="observatories"
      className="relative py-24 sm:py-32 px-4 sm:px-6 z-10 border-t border-carbon-900/10 bg-alabaster-100"
    >
      <div className="max-w-7xl mx-auto space-y-12">
        {/* Section Header */}
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4">
          <div>
            <div className="flex items-center gap-2 text-xs font-mono text-chlorophyll-deep tracking-widest uppercase mb-2">
              <span className="w-2 h-2 bg-chlorophyll inline-block" />
              <span>07 // PLANETARY OBSERVATORIES</span>
            </div>
            <h2 className="font-serif font-black text-4xl sm:text-5xl text-carbon-900 tracking-tight">
              Verified from the field.
            </h2>
          </div>
          <p className="font-mono text-xs text-carbon-900/60 max-w-sm sm:text-right">
            PEER-AUDITED FIELD CORROBORATION // AMAZONIA • CORAL SEA • HECLA BASALT
          </p>
        </div>

        {/* 3 Observatory Testimonial Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {OBSERVATORY_VOICES.map((item) => (
            <DoubleBezelCard
              key={item.id}
              enableTilt={true}
              glowColor="emerald"
              className="p-6 sm:p-8 flex flex-col justify-between h-full space-y-6"
            >
              <div className="space-y-4">
                <div className="flex items-center justify-between pb-3 border-b border-carbon-900/10 font-mono text-[10px] text-carbon-900/50">
                  <span>{item.telemetryStamp}</span>
                  <span className="text-chlorophyll-deep font-bold">VERIFIED</span>
                </div>
                <p className="font-serif text-base sm:text-lg text-carbon-900 leading-relaxed italic">
                  "{item.quote}"
                </p>
              </div>

              <div className="pt-4 border-t border-carbon-900/10 font-mono text-xs">
                <div className="font-serif font-bold text-carbon-900 text-sm">
                  {item.author}
                </div>
                <div className="text-chlorophyll-deep text-[11px] font-semibold">
                  {item.role}
                </div>
                <div className="text-carbon-900/50 text-[10px] mt-0.5">
                  {item.station} // {item.region}
                </div>
              </div>
            </DoubleBezelCard>
          ))}
        </div>
      </div>
    </section>
  );
};
